module.exports = __webpack_public_path__ + "static/media/iPhone14-6.15112052.png";